import { useState, useEffect, memo } from 'react';
import { Prompt } from 'react-router-dom';
import { Location } from 'history';

import { SaveConfirm } from 'components';

interface Props {
  when?: boolean | undefined;
  navigate: (path: string) => void;
  shouldBlockNavigation: (location: Location) => boolean;
  apply: () => Promise<void>;
}

const RouteLeavingGuard: React.FC<Props> = ({
  when,
  navigate,
  shouldBlockNavigation,
  apply,
}) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [lastLocation, setLastLocation] = useState<Location | null>(null);
  const [confirmedNavigation, setConfirmedNavigation] = useState(false);

  const closeModal = () => {
    setModalVisible(false);
  };

  const handleBlockedNavigation = (nextLocation: Location): boolean => {
    if (!confirmedNavigation && shouldBlockNavigation(nextLocation)) {
      setModalVisible(true);
      setLastLocation(nextLocation);
      return false;
    }
    return true;
  };
  const handleConfirmNavigationClick = () => {
    setModalVisible(false);
    setConfirmedNavigation(true);
  };
  useEffect(() => {
    if (confirmedNavigation && lastLocation) {
      // Navigate to the previous blocked location with your navigate function
      navigate(lastLocation.pathname);
    }
    /* eslint-disable-next-line */
  }, [confirmedNavigation, lastLocation]);

  const save = async () => {
    closeModal();
    await apply();
    setConfirmedNavigation(true);
  };

  return (
    <>
      <Prompt when={when} message={handleBlockedNavigation} />
      {/* Your own alert/dialog/modal component */}
      <SaveConfirm
        open={modalVisible}
        apply={save}
        cancel={handleConfirmNavigationClick}
      />
    </>
  );
};

export default memo(RouteLeavingGuard);
